// src/locales/ta/messageCenterCommission.js
export const messageCenterCommission = {
  pageTitle: 'செய்தி மைய கமிஷன்',
  pageDescription: 'மாத இறுதி கமிஷனை இறுதி செய்து முந்தைய கமிஷன் ஓட்டங்களை மதிப்பாய்வு செய்யவும்',
  failedToLoadCommissions: 'கமிஷன் பதிவுகளை ஏற்ற முடியவில்லை',
  finalizeLastMonth: 'கடந்த மாதத்தை இறுதி செய்',
  finalize: 'இறுதி செய்',
  finalizeConfirmMessage: 'இது {month} க்கான கமிஷனை இறுதி செய்யும், மேலும் இதை மாற்ற முடியாது. தொடரவா?',
  finalizeSuccess: 'கமிஷன் வெற்றிகரமாக இறுதி செய்யப்பட்டது',
  finalizeFailed: 'கமிஷனை இறுதி செய்ய முடியவில்லை',
  filterByMonth: 'மாதம்',
  allMonths: 'அனைத்து மாதங்கள்',
  settlementMonth: 'தீர்வு மாதம்',
  totalCommission: 'மொத்த கமிஷன்',
  status: {
    pending: 'மதிப்பாய்வு நிலுவையில்',
    completed: 'முடிந்தது',
  },
  finalizedAt: 'இறுதி செய்யப்பட்ட நேரம்',
  noCommissionsYet: 'இன்னும் கமிஷன் பதிவுகள் இல்லை',
  noCommissionsYetDescription: 'முதல் கமிஷன் பதிவை உருவாக்க கடந்த மாதத்தை இறுதி செய்யவும்',
  detailsPageTitle: 'கமிஷன் விவரங்கள்',
  detailsPageDescription: 'இந்த தீர்வு மாதத்திற்கான ஊழியர் கமிஷன் பிரிவு',
  failedToLoadCommission: 'கமிஷன் பதிவை ஏற்ற முடியவில்லை',
  markCompleted: 'முடிந்ததாக குறி',
  completeConfirmMessage: 'இந்த கமிஷனை முடிந்ததாக குறிக்கவா? இதை மாற்ற முடியாது.',
  completeSuccess: 'கமிஷன் முடிந்ததாக குறிக்கப்பட்டது',
  completeFailed: 'கமிஷனை முடிந்ததாக குறிக்க முடியவில்லை',
  finalizeMonth: 'மாதத்தை இறுதி செய்',
  selectMonthToFinalize: 'இறுதி செய்ய மாதத்தைத் தேர்ந்தெடுக்கவும்',
  reverse: 'இறுதிப்படுத்தலைத் திரும்பப் பெறு',
  reverseConfirmMessage: 'இது {month} க்கான இறுதி செய்யப்பட்ட கமிஷனைத் திரும்பப் பெற்று, அதன் கமிஷன் பதிவுகளை நிரந்தரமாக நீக்கும். தொடரவா?',
  reverseSuccess: 'கமிஷன் இறுதிப்படுத்தல் வெற்றிகரமாகத் திரும்பப் பெறப்பட்டது',
  reverseFailed: 'கமிஷன் இறுதிப்படுத்தலைத் திரும்பப் பெற முடியவில்லை',
  staffMember: 'ஊழியர்',
  userId: 'பயனர் ஐடி',
  commissionAmount: 'கமிஷன் தொகை',
  finalizedBy: 'இறுதி செய்தவர்',
  noStaffCommissionRecords: 'ஊழியர் கமிஷன் பதிவுகள் எதுவும் இல்லை',
  staffPageTitle: 'ஊழியர் கமிஷன்',
  staffPageDescription: 'கொடுக்கப்பட்ட மாதத்திற்கான ஷிப்ட் வாரியான கமிஷனைப் பார்க்கவும்',
  failedToLoadStaffReport: 'ஊழியர் கமிஷன் அறிக்கையை ஏற்ற முடியவில்லை',
  filterByUser: 'ஊழியர்',
  allUsers: 'அனைத்து ஊழியர்களும்',
  estimate: 'மதிப்பீடு',
};
